// import dependencies
import types from "../constants";

export const resourcesSet = payload => ({
    "type": types.RESOURCES_SET,
    payload
});
